module.exports = __webpack_public_path__ + "static/media/gallery.c312ae76.png";